import { cx, styled } from '@prose-ui/legacy';

const StyledImage = styled.img`
  &.fill {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Image = ({
  src,
  height,
  width,
  fill = false,
  className,
  loading = 'lazy',
  ...props
}: ImageProps) => {
  return (
    <StyledImage
      className={cx(className, { fill })}
      height={height ? height : typeof src === 'string' ? undefined : src?.height}
      loading={loading}
      src={typeof src === 'string' ? src : src.src}
      width={width ? width : typeof src === 'string' ? undefined : src?.width}
      {...props}
    />
  );
};

export type StaticImageData = {
  src: string;
  height: number | string;
  width: number | string;
  blurDataURL?: string;
  blurWidth?: number;
  blurHeight?: number;
};
export type ImageProps = {
  src: string | StaticImageData;
  alt: string;
  loading?: HTMLImageElement['loading'];
  height?: number | string;
  width?: number | string;
  fill?: boolean;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
};
